import React from 'react';
import { CheckIcon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const items = ['Complete Box Set (6 modules)', '5 Strategic Bonuses', '365-Day Coaching Curriculum', 'Lifetime access', 'Instant digital access'];
const checkoutUrl = 'https://italiano-ready.impultienda.ar/checkout';
export function PricingSection() {
  return <section id="pricing" className="bg-[#FAFAFA] px-5 py-20 pb-[05px] pt-[05px]" data-id="element-154" data-mp="1nasn4ttn3wh1">
      <div className="mx-auto max-w-xl text-center" data-id="element-155" data-mp="1s9403df8en3h">
        <p className="inline-block bg-[#0A0A0A] px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-156" data-mp="1s7sm6ks2nyyn">
          Limited-time offer
        </p>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none text-[#0A0A0A] sm:text-5xl" data-id="element-157" data-mp="2282y822df0c8">
          Everything included,{' '}
          <span className="text-[#b18b18]" data-id="element-158" data-mp="2ws43kwr37ge">one single price.</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-[#5A5A66]" data-id="element-159" data-mp="7ubs3cj92ylj">
          No upsells. No surprises.
        </p>
        <article className="mt-10 overflow-hidden border border-[#E5E5EA] bg-white text-center shadow-xl" data-id="element-160" data-mp="1mhzirbv4kjbz">
          <header className="border-t-4 border-[#d4af37] bg-[#0A0A0A] px-6 py-7" data-id="element-161" data-mp="1hnva8o67o38s">
            <h3 className="font-display text-3xl font-bold uppercase text-white" data-id="element-162" data-mp="1cr4uk1ybj9nw">
              Rugby Ready — Complete Box Set
            </h3>
            <p className="mt-2 text-sm font-semibold text-[#d4af37]" data-id="element-163" data-mp="25faewnlgmwn7">
              1 Main Box Set (6 modules) + 5 Strategic Bonuses
            </p>
          </header>
          <div className="p-7 sm:p-10" data-id="element-164" data-mp="20ecz2hnxaeov">
            <div id="offer-details" className="mb-8 scroll-mt-3 border-y border-[#E5E5EA] py-7" data-id="element-165" data-mp="1vgtkfgnbbzwe">
              <p className="mb-5 text-xs font-bold uppercase tracking-widest" data-id="element-166" data-mp="1rf80jbcd2lcp">
                What's included
              </p>
              <ul className="grid gap-3 text-left sm:grid-cols-2" data-id="element-167" data-mp="jzuyzyzanqof">
                {items.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold" data-id="element-168" data-mp="hhrsuxi2qxn5">
                    <span className="grid h-5 w-5 place-items-center rounded-full bg-[#d4af37]/20" data-id="element-169" data-mp="mfjhninfa3n4">
                      <CheckIcon className="h-3.5 w-3.5 text-[#9b7914]" data-id="element-170" data-mp="7j2a72ict95u" />
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="mt-7" data-id="element-171" data-mp="3uv3bojvx3q38">
              <p className="text-sm font-semibold text-[#5A5A66]" data-id="element-172" data-mp="3i088dx1yj06">
                Regular price: <s data-id="element-173" data-mp="3k39xv7ki0kq">$97 USD</s>
              </p>
              <div className="mt-1 flex items-baseline justify-center" data-id="element-174" data-mp="3kz9p07ohig7q">
                <span className="font-display text-5xl font-bold" data-id="element-175" data-mp="3pxl0emufgys2">$</span>
                <strong className="font-display text-8xl font-bold leading-none tracking-tight" data-id="element-176" data-mp="3pvgxo889m5td">
                  27
                </strong>
                <span className="ml-2 text-sm font-bold text-[#5A5A66]" data-id="element-177" data-mp="3fzx25mxm5955">
                  USD
                </span>
              </div>
              <div className="mt-3 flex flex-wrap justify-center gap-3" data-id="element-178" data-mp="2xbmvmgdidbwh">
                <span className="bg-[#d4af37] px-3 py-1.5 text-xs font-bold uppercase tracking-widest" data-id="element-179" data-mp="2scs0qg29nww0">
                  Save $70
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-[#5A5A66]" data-id="element-180" data-mp="369f2qx92td8s">
                  One-time payment
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-[#5A5A66]" data-id="element-181" data-mp="3g8o2k6qmhm32">
                  Lifetime access
                </span>
              </div>
            </div>
            <a href={checkoutUrl} className="cta-button -mx-2 mt-6 block w-[calc(100%+1rem)] rounded-2xl px-6 py-6 text-xl font-bold sm:text-2xl" data-id="element-182" data-mp="3p17xaw3sn6im">
              GET RUGBY READY NOW
            </a>
            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-[#5A5A66]" data-id="element-183" data-mp="2syfbkw7m52r">
              <ShieldCheckIcon className="h-4 w-4 text-[#b18b18]" data-id="element-184" data-mp="hy2ml11ty51b" />
              Backed by our 7-day money-back guarantee
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 border-t border-[#E5E5EA] pt-6 text-xs font-bold text-[#5A5A66]" data-id="element-185" data-mp="lymik1ao32lv">
              <span className="flex gap-1" data-id="element-186" data-mp="qsh9npslqjuz">
                <LockKeyholeIcon className="h-4 w-4" data-id="element-187" data-mp="vpqwqysiqjfn" />
                Secure payment
              </span>
              <span className="flex gap-1" data-id="element-188" data-mp="3v5nvzx2shybo">
                <ZapIcon className="h-4 w-4" data-id="element-189" data-mp="3v6pa6af3r0xm" />
                Instant access
              </span>
              <span className="flex gap-1" data-id="element-190" data-mp="32wg6cyto47g">
                <CreditCardIcon className="h-4 w-4" data-id="element-191" data-mp="7zn5zs0fie62" />
                Card · GooglePay · ApplePay
              </span>
            </div>
          </div>
        </article>
        <p className="mt-5 text-xs font-semibold text-[#5A5A66]" data-id="element-192" data-mp="cwn3vfn4kam3">
          You’ll be charged in your local currency.
        </p>
      </div>
    </section>;
}